// generated by the plop

import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import { TelegramChatMessageModel, TelegramChatModel } from '../../symbols';


// added by plop
export class GetChatList {
  static type = '[telegramChat] GetChatList';

  constructor(public filter: PaginateQuery<{ search: string }>, public lazy = false) {
  }
}


export class GetChatListSuccess {
  static type = '[telegramChat] GetChatListSuccess';

  constructor(public chatList: PaginatorModel<TelegramChatModel>, public lazy: boolean) {
  }
}


export class GetChatListFail {
  static type = '[telegramChat] GetChatListFail';

  constructor(public error: UnknownError) {
  }
}

export class GetUnreadMessagesCount {
  static type = '[telegramChat] GetUnreadMessagesCount';

  constructor() {
  }
}


export class GetUnreadMessagesSuccess {
  static type = '[telegramChat] GetUnreadMessagesSuccess';

  constructor(public count: number) {
  }
}


export class GetChatMessages {
  static type = '[telegramChat] GetChatMessages';

  constructor(public chatId: string, public filter?: PaginateQuery<{ search: string }>, public lazy = false) {
  }
}

export class GetChatMessagesSuccess {
  static type = '[telegramChat] GetChatMessagesSuccess';

  constructor(public chatId: string, public messages: PaginatorModel<TelegramChatMessageModel>, public lazy: boolean) {
  }
}

export class GetChatMessagesFail {
  static type = '[telegramChat] GetChatMessagesFail';

  constructor(public chatId: string, public error: UnknownError) {
  }
}


export class NewMessageWS {
  static type = '[telegramChat] NewMessageWS';

  constructor(public payload: TelegramChatMessageModel) {
  }
}

export class ReadMessageByChatId {
  static type = '[telegramChat] ReadMessageByChatId';

  constructor(public chatId: string) {
  }
}


export class SendMessageToChat {
  static type = '[telegramChat] SendMessageToChat';
  constructor(public chatId: number, public message: string) {}
}


export class SendMessageToChatSuccess {
  static type = '[telegramChat] SendMessageToChatSuccess';
}
